module.exports = __webpack_public_path__ + "img/19.79e2a87a.jpg";